import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { OAuthButtons } from './OAuthButtons';
import { Brand } from '../common/Brand';
import { TwoFactorChallenge } from './TwoFactorChallenge';

export const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mfaToken, setMfaToken] = useState<string | null>(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);
      if (result.mfaRequired && result.mfaToken) {
        setMfaToken(result.mfaToken); // switch to the code step
      } else {
        navigate('/dashboard');
      }
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Second step: account has 2FA on.
  if (mfaToken) {
    return (
      <TwoFactorChallenge
        mfaToken={mfaToken}
        onDone={() => navigate('/dashboard')}
        onCancel={() => { setMfaToken(null); setPassword(''); }}
      />
    );
  }

  return (
    <div className="auth auth-center">
      <div className="auth-card">
        <div className="auth-brand"><Brand variant="full" height={64} /></div>
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-sub">New here? <Link to="/register">Create an account</Link></p>
        <form onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}
          <div className="auth-field">
            <label className="auth-label" htmlFor="email">Email address</label>
            <input
              id="email" name="email" type="email" autoComplete="email" required
              className="auth-input" placeholder="you@example.com"
              value={email} onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="auth-field">
            <label className="auth-label" htmlFor="password">Password</label>
            <input
              id="password" name="password" type="password" autoComplete="current-password" required
              className="auth-input" placeholder="••••••••"
              value={password} onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" disabled={loading} className="auth-btn" style={{ marginTop: 6 }}>
            {loading ? <LoadingSpinner size="sm" /> : 'Sign in'}
          </button>
          <OAuthButtons />
        </form>
      </div>
    </div>
  );
};
